import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {ErrorBox} from 'iss/widgets/MessageBox';
import BootstrapCheckbox from 'iss/widgets/bootstrap/Checkbox';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';
import BootstrapInput from 'iss/widgets/bootstrap/Input';
import BootstrapRadioGroup from 'iss/widgets/bootstrap/RadioGroup';
import BootstrapTextArea from 'iss/widgets/bootstrap/TextArea';
import {formComponent} from 'iss/widgets/form/Field';

export const TextArea = wrapInput(BootstrapTextArea);
export const RadioGroup = formComponent(({onChange, disabled = false, ...props}) => {
  function onClickSafe(event) {
    if (disabled) {
      event.preventDefault();
    } else if (props.value === event.target.value) {
      onChange(null);
    }
  }
  function onChangeSafe(value) {
    if (!disabled) {
      onChange(value);
    }
  }
  // This does not use built-in disabled attribute due to styling issues, instead we prevent click events.
  return <BootstrapRadioGroup
    onChange={e => onChangeSafe(e.target.value)}
    onClick={e => onClickSafe(e)}
    disabled={disabled}
    {...props}/>;
});

export const Input = wrapInput(BootstrapInput);

function wrapInput(Component) {
  return formComponent(({onChange, ...props}) => {
    return <Component onChange={(e) => onChange(e.target.value)} {...props} />;
  });
}

/** NOTE: this does not work in Microsoft Edge as of April 2019 */
export const FileInput = formComponent(({onChange, ...props}) => {
  return <BootstrapInput onChange={(e) => onChange(e.target.files[0])} {...R.dissoc("value", props)} className="form-control-file" type="file" />;
});

export const ValidationErrorBox = formComponent(({id, error}) => {
  return <ErrorBox id={id} message={error} />;
});
export function FormFieldLoadingError({validate, valuePath, ...props}) {
  return <BootstrapFormGroup {...props} error={translate('common.genericLoadError')}>
    <ValidationErrorBox valuePath={valuePath} validate={validate} />
  </BootstrapFormGroup>;
}

export const Checkbox = formComponent(({onChange, ...props}) => {
  return <BootstrapCheckbox onChange={(e) => onChange(Boolean(e.target.checked))} {...props} />;
});



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/Inputs.jsx